/*eslint-disable*/
import React, { useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import RichTextEditor from "react-rte";
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
const useStyles = makeStyles(styles);
import SweetAlert from "react-bootstrap-sweetalert";
const useStyleData = makeStyles(stylesData);
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Box, Checkbox, CircularProgress, FormControlLabel } from "@material-ui/core";
import moment from "moment";
import 'react-toastify/dist/ReactToastify.css';
import { Form, Formik } from "formik";
import createLotteryValidationSchema from "utils/createLotteryValidationSchema";

const isValidDate = (current) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const yesterday = Datetime.moment().subtract(1, "day");
  return current.isAfter(yesterday);
};



export default function CreateLottery() {
  const navigate = useNavigate();
  const [file, setFile] = React.useState(null);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [avatar, setAvatar] = React.useState(true);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [imageurl, setImageurl] = React.useState("");
  const [alert, setAlert] = React.useState(null);
  const [editorBody, setEditorBody] = React.useState(
    RichTextEditor.createEmptyValue()
  );


  const [errorFile, setErrorFile] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");

  const [decelarationOfWheel, setDecelarationOfWheel] = React.useState(60);
  const [rpmOfWheel, setrpmOfWheel] = React.useState(3);
  const { speed } = useRef();
  const fileInput = useRef(null);

  const initialValues = {
    lotteryName: '',
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    instruction: "",
    maxRpmLotteryWheel: rpmOfWheel,
    decelarationOfLotteryWheel: decelarationOfWheel,
    maxNumOfTickets: 0,
    status: "",
    drawPrize: [],
    freeTicketSpinNo: null,
    maxTktPurchLimit: 0,
    lastTwoTktNumPrice: 0,
    jackpotSelected: false,
    LotteryTypeEvent: false,
    freeTicketSpinNo: [],
    freeTicketSpinPrize: [],
  };
  console.log(initialValues, "initialValues");








  const handleImageChange = async (e) => {
    e.preventDefault();
    setErrorFile(false);
    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) {
      console.log("image is required");
      setErrorFile(true);
      setErrorMsg("image is required");
      return false;
    }
    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      console.log("select valid image.");
      setErrorFile(true);
      setErrorMsg("Lottery image must be in jpg, jpeg,png or gif format");
      return false;
    }
    if (file.size > 262144000) {
      console.log("select valid image.");
      setErrorMsg("Lottery image must be 250 MB");
      setErrorFile(true);
      return false;
    }
    setSelectedFile(e.target.files[0]);
    setFile(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl(reader.result);
      setImageurl(e.target.files[0]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl);
  };

  const handleRemove = () => {
    setFile(null);
    setImageurl(null);
    setImagePreviewUrl(defaultAvatar);

    if (fileInput.current) {
      fileInput.current.value = null;
    }
  };
  const [showLoader, setShowLoader] = useState(false);





  const handleKeyPress = (e) => {
    const char = String.fromCharCode(e.which);
    const isValidChar = /^[0-9/: -]+$/.test(char);
    if (!isValidChar) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (values, setSubmitting) => {
    const finalPrizeObject = {};
    values.freeTicketSpinNo.forEach((spinNo, i) => {
      if (spinNo && values.freeTicketSpinPrize[i] != null) {
        finalPrizeObject[spinNo - 1] = values.freeTicketSpinPrize[i];
      }
    });

    setSubmitting(true);
    const token = localStorage.getItem("token");
    setShowLoader(true);

    const formData = new FormData();
    formData.append("lotteryName", values.lotteryName);
    formData.append("ticketPrice", values.ticketPrice);
    formData.append("numOfTicketOnSale", values.numOfTicketOnSale);
    formData.append("ticketCountdown", values.ticketCountdown);
    formData.append("startDate", values.startDate);
    formData.append("endDate", values.endDate);
    formData.append("startTime", values.startTime);
    formData.append("endTime", values.endTime);
    formData.append("lotteryDrawDate", values.lotteryDrawDate);
    formData.append("lotteryDrawTime", values.lotteryDrawTime);
    formData.append("totalDraw", values.totalDraw);
    formData.append("instruction", values.instruction);
    formData.append("maxRpmLotteryWheel", values.maxRpmLotteryWheel);
    formData.append("decelarationOfLotteryWheel", values.decelarationOfLotteryWheel);
    formData.append("maxNumOfTickets", values.maxNumOfTickets);
    formData.append("status", values.status);
    formData.append("maxTktPurchLimit", values.maxTktPurchLimit);
    formData.append("lastTwoTktNumPrice", values.lastTwoTktNumPrice);
    formData.append("jackpotSelected", values.jackpotSelected);
    formData.append("LotteryTypeEvent", values.LotteryTypeEvent);
    formData.append("totalSpin", values.totalSpin);
    formData.append("freeTicketSpinData", JSON.stringify(finalPrizeObject));
    if (values.drawPrizes && Array.isArray(values.drawPrizes)) {
      values.drawPrizes.forEach((prize, index) => {
        formData.append(`drawPrize[${index}]`, prize);
      });
    }

    formData.append("image", selectedFile);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {res.data.message}
            </span>
          }
          onConfirm={() => {
            setAlert(null);
            navigate(`/admin/ManageLotteries`);
          }}
          onCancel={() => {
            setAlert(null);
            navigate(`/admin/ManageLotteries`);
          }}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    } catch (err) {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {err?.response?.data?.message}
            </span>
          }
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    } finally {
      setShowLoader(false);
      setSubmitting(false);
    }
  };

  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Add Lottery</h4>
          </CardHeader>
          <CardBody>
            <Formik
              initialValues={initialValues}
              validationSchema={createLotteryValidationSchema}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, setSubmitting);
              }}
            >
              {({ values, errors, touched, handleBlur, handleSubmit, setFieldValue }) => {
                console.log('Formik values:', values);
                const handleChange = (e) => {
                  const { id, type, checked, value } = e.target;
                  console.log("onChange Triggered for", id, "with value:", value);
                  const newValue = type === "checkbox" ? checked : value;
                  setFieldValue(id, newValue);
                };

                const handleDateTimeChange = (value) => {
                  const isValidMoment = moment.isMoment(value) && value.isValid();

                  if (isValidMoment) {

                    setFieldValue("startDate", value.toISOString());


                    setFieldValue("startTime", value.toISOString());

                    console.log("Valid date selected:", value.toISOString());
                  } else if (value === "" || value === null || value === undefined) {

                    setFieldValue("startDate", "");
                    setFieldValue("startTime", "");
                    console.log("Date cleared.");
                  } else {
                    console.log("Invalid date entered.");

                  }
                };
                const handleEndDateTimeChange = (value) => {
                  const isValidMoment = moment.isMoment(value) && value.isValid();

                  if (isValidMoment) {

                    setFieldValue("endDate", value.toISOString());


                    setFieldValue("endTime", value.toISOString());

                    console.log("Valid end date selected:", value.toISOString());
                  } else if (value === "" || value === null || value === undefined) {

                    setFieldValue("endDate", "");
                    setFieldValue("endTime", "");
                    console.log("End date cleared.");
                  } else {
                    console.log("Invalid date entered.");

                  }
                };

                const handleLotteryDateTimeChange = (value) => {
                  const isValidMoment = moment.isMoment(value) && value.isValid();

                  if (isValidMoment) {

                    setFieldValue("lotteryDrawDate", value.toISOString());


                    setFieldValue("lotteryDrawTime", value.toISOString());

                    console.log("Valid lottery draw date selected:", value.toISOString());
                  } else if (value === "" || value === null || value === undefined) {

                    setFieldValue("lotteryDrawDate", "");
                    setFieldValue("lotteryDrawTime", "");
                    console.log("Lottery draw date cleared.");
                  } else {
                    console.log("Invalid date entered.");
                  }
                };
                const handleChangeTotalDraw = (e) => {
                  const { id, value } = e.target;


                  setFieldValue(id, value);



                };
                const handleBlurTotalDraw = (e) => {
                  handleChangeTotalDraw(e);
                }
                const [prevSpinNos, setPrevSpinNos] = useState([]);

                React.useEffect(() => {
                  const total = parseInt(values.totalDraw) || 0;
                  const updated = [...(values.drawPrizes || [])];
                  while (updated.length < total) updated.push('');
                  while (updated.length > total) updated.pop();
                  setFieldValue("drawPrizes", updated);
                }, [values.totalDraw]);

                const generateFreeTicketSpinTextFields = (values, setFieldValue) => {
                  const textFields = [];
                  for (let i = 0; i < values.totalSpin && i <= values.totalDraw - 1; i++) {
                    textFields.push(i);
                  }

                  return textFields.map((index) => (
                    <GridItem key={index} xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText={`Free ticket Spin No.`}
                        id={`freeTicketSpinNo[${index}]`}
                        type="number"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={values.freeTicketSpinNo[index] || ""}
                        handleChange={(event) => {
                          const val = event.target.value;
                          const updatedSpinNo = [...values.freeTicketSpinNo];

                          if (val === "") {
                            updatedSpinNo[index] = undefined;
                          } else {
                            updatedSpinNo[index] = Number(val);
                          }

                          const allEmpty = updatedSpinNo.every((item) => item === undefined || item === null || item === "");

                          setFieldValue(
                            "freeTicketSpinNo",
                            allEmpty ? [] : updatedSpinNo
                          );
                        }}
                        inputProps={{
                          type: "number",
                        }}
                        helperText={
                          touched.freeTicketSpinNo && errors.freeTicketSpinNo
                            ? errors.freeTicketSpinNo
                            : "Enter Free ticket Spin No."
                        }
                        error={touched.freeTicketSpinNo && Boolean(errors.freeTicketSpinNo)}
                      />
                    </GridItem>
                  ));
                };

                const generateFreeTicketSpinPrizeFields = (values, setFieldValue) => {
                  const textFields = [];
                  for (let i = 0; i < values.totalSpin && i < values.totalDraw; i++) {
                    textFields.push(i);
                  }

                  return textFields.map((index) => (
                    // <GridItem key={index} xs={12} sm={12} md={3}>
                    //   <CustomInput
                    //     labelText={`Free ticket Spin No. prize ${index + 1}`}
                    //     id={`freeTicketSpinPrize[${index}]`}
                    //     type="number"
                    //     formControlProps={{
                    //       fullWidth: true,
                    //     }}
                    //     value={values.freeTicketSpinPrize[index] || ""}
                    //     handleChange={(event) => {
                    //       const val = event.target.value;
                    //       const updatedPrize = [...values.freeTicketSpinPrize];

                    //       // If empty, remove this entry
                    //       if (val === "") {
                    //         updatedPrize[index] = undefined;
                    //       } else {
                    //         updatedPrize[index] = Number(val);
                    //       }

                    //       // Check if all values are empty
                    //       const allEmpty = updatedPrize.every((item) => item === undefined || item === null || item === "");

                    //       setFieldValue(
                    //         "freeTicketSpinPrize",
                    //         allEmpty ? [] : updatedPrize
                    //       );
                    //     }}

                    //     inputProps={{
                    //       type: "number",
                    //     }}
                    //     helperText={
                    //       touched.freeTicketSpinPrize && errors.freeTicketSpinPrize
                    //         ? errors.freeTicketSpinPrize
                    //         : "Enter the Free ticket Spin Prize."
                    //     }
                    //     error={touched.freeTicketSpinPrize && Boolean(errors.freeTicketSpinPrize)}
                    //   />
                    // </GridItem>

                    <GridItem key={index} xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText={`Free ticket Spin No. prize ${index + 1}`}
                        id={`freeTicketSpinPrize[${index}]`}
                        type="number"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={values.freeTicketSpinPrize[index] || ""}
                        handleChange={(event) => {
                          const val = event.target.value;
                          const updatedPrize = [...values.freeTicketSpinPrize];

                          // If empty, remove this entry
                          if (val === "") {
                            updatedPrize[index] = undefined;
                          } else {
                            // Convert to number with decimal support
                            updatedPrize[index] = parseFloat(val);
                          }

                          // Check if all values are empty
                          const allEmpty = updatedPrize.every((item) => item === undefined || item === null || item === "");

                          setFieldValue(
                            "freeTicketSpinPrize",
                            allEmpty ? [] : updatedPrize
                          );
                        }}
                        inputProps={{
                          type: "number",
                          step: "0.01", // Allows 2 decimal places
                          min: "0", // Optional: prevents negative values
                        }}
                        helperText={
                          touched.freeTicketSpinPrize && errors.freeTicketSpinPrize
                            ? errors.freeTicketSpinPrize
                            : "Enter the Free ticket Spin Prize (decimal values allowed)."
                        }
                        error={touched.freeTicketSpinPrize && Boolean(errors.freeTicketSpinPrize)}
                      />
                    </GridItem>
                  ));
                };

                React.useEffect(() => {
                  if (!values.totalSpin || values.totalSpin === 0) {
                    setFieldValue("freeTicketSpinNo", []);
                    setFieldValue("freeTicketSpinPrize", []);
                  }
                }, [values.totalSpin, setFieldValue]);

                React.useEffect(() => {
                  const handleSliderChange = () => {
                    const sliderHandle = document
                      .getElementById("maxRpmLotteryWheel")
                      .querySelector(".noUi-handle");
                    const valueText = sliderHandle.getAttribute("aria-valuetext");
                    console.log(valueText);
                  };

                  if (
                    !document
                      .getElementById("maxRpmLotteryWheel")
                      .classList.contains("noUi-target")
                  ) {
                    Slider.create(document.getElementById("maxRpmLotteryWheel"), {
                      start: [60],
                      tooltips: true,

                      connect: [true, false],
                      step: 1,

                      range: { min: 60, max: 120 },
                    }).on("update", (values, handle) => {


                      setrpmOfWheel(parseFloat(values[handle]));

                    });
                  }

                  if (
                    !document
                      .getElementById("decelarationOfLotteryWheel")
                      .classList.contains("noUi-target")
                  ) {
                    Slider.create(document.getElementById("decelarationOfLotteryWheel"), {
                      start: [3],
                      connect: [true, false],
                      tooltips: true,
                      step: 1,
                      range: { min: 3, max: 7 },
                    }).on("update", (values, handle) => {


                      setDecelarationOfWheel(parseFloat(values[handle]));
                      console.log(values);
                    });
                  }

                  const sliderElement = document.getElementById("maxRpmLotteryWheel");
                  sliderElement.addEventListener("change", handleSliderChange);

                  return function cleanup() {
                    sliderElement.removeEventListener("change", handleSliderChange);
                  };
                }, []);
                const handleSimple = (e) => {
                  const name = e.target.name || e.target.id;
                  const value = e.target.value;
                  setFieldValue(name, value);
                };


                return (
                  <Form>
                    <GridContainer>
                      <GridItem xs={12} sm={4} md={12}>
                        <legend>Lottery Image</legend>
                        <ImageUpload
                          avatar
                          fileValue={file}
                          imagePreviewUrlValue={imagePreviewUrl}
                          handleImageChange={handleImageChange}
                          handleRemove={handleRemove}
                          addButtonProps={{
                            color: "rose",
                            round: true,
                          }}
                          changeButtonProps={{
                            color: "rose",
                            round: true,
                          }}
                          removeButtonProps={{
                            color: "danger",
                            round: true,
                          }}
                        />
                        {errorFile ? (
                          <h1 style={{ color: "red", fontSize: "14px" }}>
                            {errorMsg}
                          </h1>
                        ) : (
                          ""
                        )}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText="Lottery Name"
                          id="lotteryName"
                          handleChange={handleChange}


                          onBlur={handleBlur}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            value: values.lotteryName
                          }}
                          error={touched.lotteryName && Boolean(errors.lotteryName)}
                          helperText={touched.lotteryName && errors.lotteryName
                            ? errors.lotteryName
                            : "Please enter the Lottery Name"}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Maximum Number Of Tickets"
                          type="number"
                          id="maxNumOfTickets"
                          handleChange={handleChange}
                          onBlur={handleBlur}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "number",
                            value: values.maxNumOfTickets || "",
                            className: "no-spinner",
                          }}
                          helperText={
                            touched.maxNumOfTickets && errors.maxNumOfTickets
                              ? errors.maxNumOfTickets
                              : "Enter the maximum number of tickets"
                          }
                          error={touched.maxNumOfTickets && Boolean(errors.maxNumOfTickets)}


                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          type="number"
                          labelText="Ticket Price"
                          id="ticketPrice"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          handleChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{
                            type: "number",
                            value: values.ticketPrice || ""
                          }}
                          helperText={
                            touched.ticketPrice
                              ? errors.ticketPrice
                              : "Enter the maximum number of ticket Price"
                          }
                          error={touched.ticketPrice && Boolean(errors.ticketPrice)}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText="Number Of Ticket On Sale"
                          type="number"
                          id="numOfTicketOnSale"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          handleChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{
                            type: "number",
                            value: values.numOfTicketOnSale || ""
                          }}
                          helperText={
                            touched.numOfTicketOnSale
                              ? errors.numOfTicketOnSale
                              : "Enter the maximum number of ticket On Sale"
                          }
                          error={touched.numOfTicketOnSale && Boolean(errors.numOfTicketOnSale)}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <InputLabel className={classes.label}>
                          Start Date and Time
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>

                          <Datetime
                            id="startDate"
                            inputProps={{
                              placeholder: "Start Date and Time",
                              onKeyPress: handleKeyPress,
                            }}
                            value={values.startDate ? moment(values.startDate) : ""}
                            onChange={handleDateTimeChange}
                            isValidDate={isValidDate}
                          />
                          {touched.startDate && errors.startDate && (
                            <div style={{ color: "red", marginTop: "5px" }}>{errors.startDate}</div>
                          )}

                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <InputLabel className={classes.label}>
                          End Date and Time
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>

                          <Datetime
                            id="endDate"
                            inputProps={{
                              placeholder: "End Date and Time",
                              onKeyPress: handleKeyPress,
                            }}
                            value={values.endDate ? moment(values.endDate) : ""}
                            onChange={handleEndDateTimeChange}
                            isValidDate={isValidDate}
                          />
                          {touched.endDate && errors.endDate && (
                            <div style={{ color: "red", marginTop: "5px" }}>{errors.endDate}</div>
                          )}
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <InputLabel className={classes.label}>
                          Lottery Draw Date and Time
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>


                          <Datetime
                            id="lotteryDrawDate"
                            inputProps={{
                              placeholder: "Lottery Draw Date and Time",
                              onKeyPress: handleKeyPress,
                            }}
                            value={values.lotteryDrawDate ? moment(values.lotteryDrawDate) : ""}
                            onChange={handleLotteryDateTimeChange}
                            isValidDate={isValidDate}
                          />
                          {touched.lotteryDrawDate && errors.lotteryDrawDate && (
                            <div style={{ color: "red", marginTop: "5px" }}>{errors.lotteryDrawDate}</div>
                          )}
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <FormControl
                          fullWidth
                          className={classes.selectFormControl}
                          style={{ paddingTop: "8px" }}
                          error={touched.status && Boolean(errors.status)}
                        >
                          <InputLabel
                            htmlFor="status"
                            className={classes.selectLabel}
                          >
                            Status
                          </InputLabel>
                          <Select
                            id="status"
                            name="status"
                            value={values.status} // Formik-controlled value
                            onChange={(e) => setFieldValue("status", e.target.value)} // Formik way to set value
                            onBlur={handleBlur} // Track touched state
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                          >
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={true}
                            >
                              Active
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={false}
                            >
                              Inactive
                            </MenuItem>
                          </Select>
                          {touched.status && errors.status && (
                            <div style={{ color: "red", marginTop: "5px" }}>{errors.status}</div>
                          )}
                        </FormControl>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={3}>
                        {" "}
                        <CustomInput
                          labelText="Total Draw"
                          type="number"
                          id="totalDraw"
                          handleChange={handleChangeTotalDraw}
                          onBlur={handleBlurTotalDraw}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "number",
                            value: values.totalDraw || "",
                          }}
                          error={touched.totalDraw && Boolean(errors.totalDraw)}
                          helperText={
                            touched.totalDraw && errors.totalDraw
                              ? errors.totalDraw
                              : "Enter the maximum number of total draw"
                          }
                        />
                      </GridItem>

                      {values?.drawPrizes?.map((prize, index) => (
                        <GridItem key={index} xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText={`Draw Prize ${index + 1}`}
                            id={`drawPrizes.${index}`}
                            value={prize}
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{ type: "number" }}
                            error={
                              touched.drawPrizes?.[index] &&
                              Boolean(errors.drawPrizes?.[index])
                            }
                            helperText={
                              touched.drawPrizes?.[index] && errors.drawPrizes?.[index]
                                ? errors.drawPrizes[index]
                                : "Enter prize amount"
                            }
                          />
                        </GridItem>
                      ))}
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText="Total No. of Free ticket"
                          type="number"
                          id="totalSpin"
                          handleChange={handleChange}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "number",
                            value: values.totalSpin || "",
                          }}

                          helperText={
                            touched.totalSpin && errors.totalSpin
                              ? errors.totalSpin
                              : "Enter the maximum number of Free ticket spins"
                          }
                          error={touched.totalSpin && Boolean(errors.totalSpin)}
                        />
                      </GridItem>
                      {generateFreeTicketSpinTextFields(values, setFieldValue)}
                      {generateFreeTicketSpinPrizeFields(values, setFieldValue)}


                      <GridItem xs={12} sm={12} md={6}>
                        <legend style={{ marginBottom: "45px" }}>
                          Maximum Rpm Lottery Wheel
                        </legend>
                        <div
                          className="slider-primary"
                          id="maxRpmLotteryWheel"
                          ref={speed}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <legend style={{ marginBottom: "45px" }}>
                          Deceleration Of Lottery Wheel
                        </legend>
                        <div
                          className="slider-primary"
                          id="decelarationOfLotteryWheel"
                          onChange={handleSimple}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Max Ticket Purchase Limit"
                          type="number"
                          id="maxTktPurchLimit"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          handleChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{
                            type: "number",
                            value: values.maxTktPurchLimit || "",
                          }}
                          helperText={
                            touched.maxTktPurchLimit && errors.maxTktPurchLimit
                              ? errors.maxTktPurchLimit
                              : "Enter the maximum number of Free ticket spins"
                          }
                          error={touched.maxTktPurchLimit && Boolean(errors.maxTktPurchLimit)}

                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4} sx={{ padding: "10px" }}>
                        <Box display="flex" alignItems="flex-end" height="100%">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChange}
                                color="primary"
                                id="jackpotSelected"
                                checked={values.jackpotSelected}
                              />
                            }
                            label="Enable Jackpot"
                          />
                        </Box>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4} sx={{ padding: "10px" }}>
                        <Box display="flex" alignItems="flex-end" height="100%">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChange}
                                color="primary"
                                id="LotteryTypeEvent"
                                checked={values.LotteryTypeEvent}
                              />
                            }
                            label="Event Lottery"
                          />
                        </Box>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={12}>
                        <InputLabel className={classes.label}>Instruction</InputLabel>
                        <br />
                        <RichTextEditor
                          value={editorBody}
                          onChange={(newValue) => {
                            setEditorBody(newValue);
                            setFieldValue("instruction", newValue.toString("html"));
                          }}
                          style={{ height: "300px" }}
                        />
                      </GridItem>
                    </GridContainer>

                    {alert}

                    <Button
                      color="rose"
                      className={classes.registerButton}
                      type="submit"
                      disabled={showLoader}
                    >
                      {showLoader ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Add Lottery"
                      )}
                    </Button>

                  </Form>
                )
              }}
            </Formik>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
